import React, { useEffect, useState, useMemo } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import CambioEstadoTraeas from "./CambioEstadoTraeas";
import MaterialReactTable from "material-react-table";
import { Box, Typography } from "@mui/material";
import InstructivoNc from "../../Instructivos/InstrucionAvanceNc.docx";
import InstructivoSeg from "../../Instructivos/EsquemaSeguimiento.pdf";
import ReasignarTareaModal from "./ReasignarTarea";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

function Avance(props) {
  const cookie = new Cookies();
  const urlendpoint =
    props.rol === "LIDER" || cookie.get("tipo_Usuario") == 1
      ? `https://suadesarrollo.azurewebsites.net/api/obtenerTareasPorSolicitud/${props.idSolicitud}`
      : `https://suadesarrollo.azurewebsites.net/api/ObtenerTareaPorEvaluadorIdSolicitudId?EvaluadorId=${props.idEvaluador}&SolicitudId=${props.idSolicitud}`;

  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalReasignarOpen, setModalReasignarOpen] = useState(false);
  const [tareaSeleccionada, setTareaSeleccionada] = useState(null);
  const [list, setList] = useState([]);
  const closeModal = () => setIsOpen(false);
  const fetchTareas = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchTareas();
  }, [urlendpoint]);

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id" },
      { accessorKey: "evaluador", header: "Evaluador" },
      { accessorKey: "nombretarea", header: "Tarea" },
      { accessorKey: "estado", header: "Estado" },
      { accessorKey: "solicitud", header: "Solicitud" },
      { accessorKey: "evaluadorId", header: "EvaluadorId" },
      { accessorKey: "rolEvaluador", header: "rolEvaluador" },
    ],
    [],
  );

  const renderContentWithLineBreaks = (text = "") =>
    text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Avance
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "50px",
            right: "10px",
            border: "none",
            background: "transparent",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ❌
        </button>
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Tareas Asignadas
              </h6>

              <a
                href={props.tipoSolicitud == 5 ? InstructivoNc : InstructivoSeg}
                download
              >
                <button className="btn btn-warning">Especificación</button>
              </a>
            </div>

            <div className="card-body">
              <MaterialReactTable
                columns={columns}
                data={list}
                enableEditing
                renderDetailPanel={({ row }) => (
                  <Box>
                    <Typography>
                      Comentarios:
                      {renderContentWithLineBreaks(row.original.comentarios)}
                    </Typography>
                  </Box>
                )}
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <CambioEstadoTraeas
                      idTarea={row.getValue("id")}
                      idSolicitud={row.getValue("solicitud")}
                      idEvaluador={row.getValue("evaluadorId")}
                      comentarios={row.original.comentarios}
                      nombreTarea={row.getValue("nombretarea")}
                      idInstitucion={props.idInstitucion}
                      onActualizado={fetchTareas} // 🔥 clave
                    />

                    {props.rol === "LIDER" && (
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => {
                          setTareaSeleccionada({
                            idTarea: row.getValue("id"),
                            idSolicitud: row.getValue("solicitud"),
                          });
                          setModalReasignarOpen(true);
                        }}
                      >
                        Reasignar
                      </button>
                    )}

                    <ReasignarTareaModal
                      isOpen={modalReasignarOpen}
                      onClose={() => setModalReasignarOpen(false)}
                      idTarea={tareaSeleccionada?.idTarea}
                      idSolicitud={tareaSeleccionada?.idSolicitud}
                      onReasignado={fetchTareas}
                    />
                  </Box>
                )}
              />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default Avance;
